import msLogo from './microsoft-logo.svg';
import useSso from './sso.controller';

const ID = 'sso';
export interface SsoProps {
    callback?: () => void;
    keepLoggedIn?: boolean;
}

const Sso = (props: SsoProps) => {
    const viewProps = useSso(props);

    if (!viewProps.provider || !viewProps.url) {
        return <></>;
    }

    let content = <></>;

    switch (viewProps.provider.type) {
        case 'microsoft':
            content = (
                <a
                    className='flex h-[41px] flex-row items-center justify-start border-[1px] border-[#8C8C8C] bg-[#FFFFFF] text-[#5E5E5E] hover:border-[#2F2F2F] hover:bg-[#2F2F2F] hover:text-[#FFFFFF]'
                    href={viewProps.url}
                    onClick={viewProps.onSsoClick}
                    id={ID}>
                    <img
                        src={msLogo}
                        className='px-[12px]'
                        alt='Microsoft'
                    />
                    <span className='pe-[12px] font-[15px]'>Sign in with Microsoft</span>
                </a>
            );
            break;
        default:
            content = (
                <a
                    rel='noreferrer'
                    className='bg-always-white border-border-default inline-flex h-12 items-center justify-center self-stretch rounded-xl border-1 p-4'
                    href={viewProps.url}
                    onClick={viewProps.onSsoClick}
                    target='_blank'
                    id={ID}>
                    Sign in with {viewProps.provider.type}
                </a>
            );
    }

    return (
        <>
            <div
                id={ID + '-divider'}
                className='inline-flex items-center justify-center gap-4'>
                <div className='bg-border-default h-px w-24' />
                <div className='justify-start text-center text-base font-medium text-stone-950'>or</div>
                <div className='bg-border-default h-px w-24' />
            </div>
            <div
                id={ID + '-options'}
                className='flex flex-col items-start justify-start gap-2'>
                {content}
            </div>
        </>
    );
};

export default Sso;
